import { render, staticRenderFns } from "./DemoVzn14View.vue?vue&type=template&id=395e87b2&"
import script from "./DemoVzn14View.vue?vue&type=script&lang=js&"
export * from "./DemoVzn14View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports